import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight, Plus } from "lucide-react";
import { track } from "../../lib/tracking";const PILLS = [
  "112 — Algemeen alarmnummer",
  "144 — Dierenambulance",
  "Dierenarts",
  "Spoedkliniek 24/7",
  "Hoefsmid",
  "Tandarts",
  "Fysio / Osteo",
];

export const EmergencyCallout = () => {
  return (
    <section
      id="emergency"
      data-testid="emergency-callout"
      className="bg-background py-20 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-[2rem] border border-red-200/60 bg-gradient-to-br from-red-50 via-[hsl(var(--surface))] to-[hsl(var(--surface-secondary))] p-8 sm:p-12 lg:p-16">
          {/* Decorative red + badge */}
          <div className="pointer-events-none absolute -right-6 -top-6 hidden sm:block">
            <span className="grid h-32 w-32 place-items-center rounded-full bg-red-600 text-white shadow-[0_20px_60px_-15px_rgba(220,38,38,0.55)]">
              <Plus className="h-14 w-14" strokeWidth={2.5} />
            </span>
          </div>

          <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
            <div className="lg:col-span-7">
              <span className="inline-flex items-center gap-2 rounded-full bg-red-600 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.22em] text-white">
                <Plus className="h-3 w-3" strokeWidth={2.5} />
                Spoed
              </span>
              <h2 className="mt-5 font-display text-4xl font-medium leading-[1.05] text-[hsl(var(--ink))] text-balance sm:text-5xl lg:text-6xl">
                In een noodgeval is{" "}
                <em className="italic text-red-600">elke seconde</em> waardevol.
              </h2>
              <p className="mt-6 max-w-xl text-[hsl(var(--ink-soft))]">
                EquiSight bundelt alle noodnummers van jouw paard op één scherm.
                Tik op de rode <span className="inline-flex items-center gap-1 font-medium text-red-600">+ knop</span>{" "}
                en bel of WhatsApp dierenarts, kliniek of hoefsmid direct —
                zonder zoeken.
              </p>

              <ul className="mt-8 flex flex-wrap gap-2">
                {PILLS.map((p) => (
                  <li
                    key={p}
                    className="rounded-full border border-[hsl(var(--border))] bg-[hsl(var(--surface))] px-3.5 py-1.5 text-xs text-[hsl(var(--ink))]"
                  >
                    {p}
                  </li>
                ))}
              </ul>

              <div className="mt-10 flex flex-wrap items-center gap-3">
                <Link
                  to="/noodnummerpaard"
                  data-testid="emergency-cta-primary"
                  onClick={() =>
                    track("cta_click", { label: "home_emergency_primary" })
                  }
                  className="group inline-flex items-center gap-2 rounded-full bg-red-600 px-7 py-4 text-sm font-medium text-white transition-all hover:-translate-y-0.5 hover:bg-red-700"
                >
                  <Phone className="h-4 w-4" strokeWidth={1.8} />
                  Bekijk noodnummers
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" strokeWidth={1.8} />
                </Link>
                <a
                  href="#waitlist"
                  data-testid="emergency-cta-secondary"
                  onClick={() =>
                    track("cta_click", { label: "home_emergency_secondary" })
                  }
                  className="inline-flex items-center gap-2 rounded-full border border-[hsl(var(--ink))] px-7 py-4 text-sm font-medium text-[hsl(var(--ink))] transition-all hover:-translate-y-0.5 hover:bg-[hsl(var(--ink))] hover:text-[hsl(var(--background))]"
                >
                  Zet nu klaar
                </a>
              </div>
            </div>

            <div className="lg:col-span-5">
              <img
                src="/assets/emergency-callout.png"
                alt="EquiSight noodcontacten scherm — direct bellen of WhatsAppen met dierenarts, kliniek en hoefsmid"
                data-testid="emergency-callout-image"
                className="mx-auto h-auto w-full max-w-[360px] drop-shadow-[0_30px_60px_rgba(220,38,38,0.18)]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmergencyCallout;
